export const LOAD_CONFIGURATION = 'search/load-configuration'
export const LOAD_CONFIGURATION_FINISHED = 'search/load-configuration-finished'
export const LOAD_CONFIGURATION_FAILED = 'search/load-configuration-failed'
export const SET_PROPERTY = 'search/set-property'
export const SET_INTEGRATOR_SHORTNAME = 'search/set-integratorshortname'

export const loadConfiguration = (payload) => ({
  type: LOAD_CONFIGURATION,
  payload
})

export const loadConfigurationFinished = (payload) => ({
  type: LOAD_CONFIGURATION_FINISHED,
  payload
})

export const loadConfigurationFailed = (payload = []) => ({
  type: LOAD_CONFIGURATION_FAILED,
  payload
})

export const setProperty = (payload) => ({
  type: SET_PROPERTY,
  payload
})

export const setIntegratorShortName = (payload) => ({
  type: SET_INTEGRATOR_SHORTNAME,
  payload
})
